/*
Player position map:
- Do not show 90s played value unless MINIMUM value is met
- Show coloured border only between MINIMUM & THRESHOLD values
- Show solid colour where THRESHOLD value is met
*/
export const PLAYED_90S_THRESHOLD = 2;
export const PLAYED_90S_MINIMUM = 0.1;
